import React from 'react';

const Logo = ({ size = 24, className = '' }) => {
  const fontSize = 24;

  return (
    <span
      className={className}
      style={{
        display: 'inline-flex',
        alignItems: 'baseline',
        fontFamily: "'Space Grotesk','Poppins','Inter','Segoe UI',sans-serif",
        fontWeight: 800,
        letterSpacing: '0.06em',
        fontSize,
        textTransform: 'uppercase',
        color: '#4C1D95',
      }}
    >
      Vrooomies
    </span>
  );
};

export default Logo;

